export interface AppTool {
  id: string;
  label: string;
  hint: string;
  path: string;
  icon: string;
  permission: string;
  keywords: string[];
  load?: () => Promise<unknown>;
}

export const APP_TOOLS: AppTool[] = [
  {
    id: 'products',
    label: 'Produits',
    hint: 'Catalogue et disponibilité',
    path: '/outils/produits',
    icon: 'package',
    permission: 'VIEW_PRODUCTS',
    keywords: ['produit', 'produits', 'stock', 'catalogue', 'rupture', 'disponible'],
    load: () => import('../pages/Tools/Products/ProductCatalogPage')
  }
];

function fold(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

export function filterTools(tools: AppTool[], query: string): AppTool[] {
  const term = fold(query.trim());
  if (!term) return tools;

  return tools
    .map((tool) => {
      const label = fold(tool.label);
      const hint = fold(tool.hint);
      const keywords = fold(tool.keywords.join(' '));
      let score = 0;
      if (label.startsWith(term)) score = 3;
      else if (label.includes(term)) score = 2;
      else if (hint.includes(term) || keywords.includes(term)) score = 1;
      return { tool, score };
    })
    .filter((row) => row.score > 0)
    .sort((a, b) => b.score - a.score || a.tool.label.localeCompare(b.tool.label, 'fr'))
    .map((row) => row.tool);
}
